<template>
  <div class="tag-label" :class="{ 'tag-label--inline': inline }">
    <span v-if="showTitle" class="tag-label__title">{{ tag.title }}</span>
    <span v-if="programTypeKey || scheduleTypeKey" class="tag-label__badges">
      <b-badge v-if="programTypeKey" :variant="programTypeVariant" class="tag-label__badge">
        {{ programTypeLabel }}
      </b-badge>
      <b-badge
        v-if="scheduleTypeKey"
        :variant="scheduleTypeVariant"
        pill
        class="tag-label__badge tag-label__badge--schedule"
      >
        <i class="material-icons tag-label__badge-icon">schedule</i>{{ scheduleTypeLabel }}
      </b-badge>
    </span>
  </div>
</template>

<script>
// Normalize backend aliases to canonical program type keys used in locales.
const PROGRAM_TYPE_ALIASES = {
  online: 'virtual',
  inperson: 'onsite',
  hybrid: 'blended'
};

const PROGRAM_TYPE_VARIANTS = {
  virtual: 'info',
  onsite: 'warning',
  blended: 'success'
};

const SCHEDULE_TYPE_VARIANTS = {
  daytime: 'primary',
  evening: 'dark',
  weekend: 'success'
};

export default {
  name: 'TagLabel',
  props: {
    tag: {
      type: Object,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    programTypeKey() {
      const value = String(this.tag.program_type || '').toLowerCase();
      if (!value) return '';
      return PROGRAM_TYPE_ALIASES[value] || value;
    },
    scheduleTypeKey() {
      return String(this.tag.schedule_type || '').toLowerCase();
    },
    programTypeVariant() {
      return PROGRAM_TYPE_VARIANTS[this.programTypeKey] || 'secondary';
    },
    scheduleTypeVariant() {
      return SCHEDULE_TYPE_VARIANTS[this.scheduleTypeKey] || 'secondary';
    },
    programTypeLabel() {
      const key = `programTypes.${this.programTypeKey}`;
      return this.$te(key) ? this.$t(key) : this.tag.program_type;
    },
    scheduleTypeLabel() {
      const key = `scheduleTypes.${this.scheduleTypeKey}`;
      return this.$te(key) ? this.$t(key) : this.tag.schedule_type;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;

  &--inline {
    justify-content: flex-start;
    width: auto;

    .tag-label__title {
      white-space: nowrap;
      word-break: normal;
    }
  }

  &__title {
    white-space: normal;
    word-break: break-word;
  }

  &__badges {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    gap: 0.2rem;
  }

  &__badge {
    font-size: 0.6rem;
    padding: 0.15rem 0.3rem;
    font-weight: 600;

    &--schedule {
      display: inline-flex;
      align-items: center;
      gap: 0.1rem;
      padding: 0.15rem 0.4rem;
    }
  }

  &__badge-icon {
    font-size: 0.75rem;
    line-height: 1;
  }
}
</style>
